import { render, staticRenderFns } from "./GameDashboard.vue?vue&type=template&id=f282f6c0&scoped=true&"
import script from "./GameDashboard.vue?vue&type=script&lang=js&"
export * from "./GameDashboard.vue?vue&type=script&lang=js&"
import style0 from "./GameDashboard.vue?vue&type=style&index=0&id=f282f6c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f282f6c0",
  null
  
)

export default component.exports